export default __webpack_public_path__ + "static/media/Bloodsire Harness.769aa76f.jpg";